export function getClosestScrollableElement(element) {
    while (element && !['auto', 'overlay', 'scroll'].includes(getComputedStyle(element).overflowY)) {
        element = 'offsetParent' in element ? element.offsetParent : element;
    }
    return element;
}
